<template>
    <div class="sidebar">
        <img
            class="firzok"
            :src="require('@/assets/firzok.png')"
            alt="Firzok"
            href="/"
        />
        <nav class="links">
            <SidebarLink scrollTo="welcome">Welcome</SidebarLink>
            <SidebarLink scrollTo="intro">Intro</SidebarLink>
            <SidebarLink scrollTo="about">About</SidebarLink>
            <SidebarLink scrollTo="skills">Skills</SidebarLink>
            <SidebarLink scrollTo="education">Education</SidebarLink>
            <SidebarLink scrollTo="workExperience">Work Experience</SidebarLink>
            <SidebarLink scrollTo="contact">Contact</SidebarLink>
        </nav>
        <ThemeButton
            class="theme-btn"
            :userTheme="userTheme"
            @toggle="$emit('toggleTheme')"
        />
    </div>
</template>

<script>
import SidebarLink from "../Sidebar/SidebarLink.vue";
import ThemeButton from "../ThemeButton";
export default {
    name: "Sidebar",
    components: { ThemeButton, SidebarLink },
    props: {
        userTheme: { type: String, default: "dark" },
    },
    methods: {
        scrollTo(id) {
            document.getElementById(id).scrollIntoView({
                behavior: "smooth",
                block: "end",
            });
        },
    },
};
</script>

<style scoped lang="scss">
.sidebar {
    max-width: 13vw;
    float: left;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    bottom: 0;
    padding: 2.5vw;

    transition: 0.3s ease;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    background-color: $lightGrey;

    .firzok {
        width: 12vw;
        position: fixed;
        top: 2%;
        filter: drop-shadow(0px 0px 3px #fff);
    }
    .theme-btn {
        position: absolute;
        bottom: 2rem;
    }
}
.dark .sidebar {
    color: $white;
    background-color: $grey;
}
</style>
